/**
 * 編集情報データクラス
 * */
export class editInfo {

	// リテーラID
	public retailerId: string;

	// 一時編集ID(暗号化)
	public tempId: string;

	// 世代番号
	public idx: number;

	// 画像情報
	public photoList: photo[];

	// 枠情報
	public photoUseList: photoUse[];

	// あいさつ文情報
	public greetingInfo: greetingInfo[];

	// スタンプマスタ
	public stampInfo: stampInfo[];

	// Myスタンプ一覧
	public myStampList: photo[];

	// Myスタンプ配置一覧
	public myStampUseList: uploadStampUseInfo[];

	// 手書きスタンプ一覧
	public fontgenicList: photo[];

	// 手書きスタンプ配置一覧
	public fontgenicUseList: uploadStampUseInfo[];

	// 印刷タイプ(1:印刷 2: 銀塩)
	public printType: string;

	// 保存名
	public saveAs: string;

	// テンプレート記号
	public dsnNo: string;
}

// 写真情報
export class photo {

	public fileId: string;
	public fileNameKey: string;
	public fileName: string;
	public height: number;
	public width: number;
	public uploadDate: Date;
	public deleteDate: Date;
	public deleteFlg: boolean;
	public isUsed: boolean;
}

// 写真枠情報
export class photoUse {

	public fileId: string;
	public useI2: boolean;
	public brightId: number;
	public sonbpVp: sonbpVp;
}

// あいさつ文情報
export class greetingInfo {
	public id: number;
	public greetingNo: string;
	public fontId: string;
	public size: number;
	public colorId: string;
	public outlineColor: string;
	public align: string;
	public direction: string;
	public text: string;
	public sonbpVp: sonbpVp;
}

// スタンプ情報
export class stampInfo {
	public fileId: string;
	public sonbpVp: sonbpVp;
}

// アップロードスタンプ情報
export class uploadStampUseInfo extends photo {

	public colorId: string;
	public sonbpVp: sonbpVp;
}

export class sonbpVp {
	public idx: number;
	public brightId: number;
	public x: number;
	public y: number;
	public width: number;
	public height: number;
	public angle: number;
}

